import React, {useState} from "react";

import { sendVenueHire } from "network/ApiAxiosTickets.js";

// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import Header from "componentsHomePage/Header/Header.js";
import Footer from "components/Footers/AdminFooter.js";
import HeaderLinks from "componentsHomePage/Header/HeaderLinks.js";
import Parallax from "componentsHomePage/Parallax/Parallax.js";

import GridContainer from "componentsHomePage/Grid/GridContainer.js";
import GridItem from "componentsHomePage/Grid/GridItem.js";
import { Button,FormGroup,Form,Input,InputGroup,Row,Col} from "reactstrap";


import styles from "../assets/jss/material-kit-react/views/landingPage.js";
import stylesSection from "../assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
import { Link } from "react-router-dom";

const useStyles = makeStyles(styles);
const useStylesSection = makeStyles(stylesSection);

function Venue(props) {
    const classes = useStyles();
    const classesSection = useStylesSection();
    const { ...rest } = props;

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState();
    const [eventDate, setEventDate] = useState();
    const [people, setPeople] = useState();
    const [venue, setVenue] = useState('');
    const [desc, setDesc] = useState('');
    const [success, setSuccess] = useState();

    const sendHireForm = async()=>{
        console.log(name , email , phone , eventDate , people , venue , desc)
        if(name != '' & email != '' & phone != '' & eventDate != '' & people != '' & venue != '' & desc != ''){
            const resp = await sendVenueHire(name,email,phone,eventDate,people,venue,desc)
            console.log(resp)
            if(resp.data.success){
                setSuccess({color:'green',text:'Your Request Was Sent'})
            }else{
                setSuccess({color:'red',text:'Something went wrong please try again later, or use one of our other contacts'})
            }
        }else{
            setSuccess({color:'red',text:'You need to fill out all the fields in the form!'})
        }
    }

  return (
    <div style={{backgroundColor:'#0B22E8'}}>
      <Header
        color="transparent"
        brand="Celebrationjump LDA"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 200,
          color: "info",
        }}
        {...rest}
      />
      <Parallax filter/>
      <div className={classNames(classes.main, classes.mainRaised)} >
        <div className={classes.container}>
            <div className={classesSection.section}>
                
                <GridContainer justifyContent="center">
                    <GridItem xs={12} sm={12} md={8}>
                        <h1 className={classesSection.title}>Venue Hire</h1>
                        <Link to='/bars'>
                            <Button className='btn-outline-info' >View Venues</Button>
                        </Link>
                        <hr/>
                        <Form role="form">
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <InputGroup className="input-group-alternative mb-3">
                                        <Input
                                            placeholder="Name"
                                            type="text"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                        />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <InputGroup className="input-group-alternative mb-3">
                                        <Input
                                            placeholder="Email"
                                            type="email"
                                            autoComplete="new-email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <InputGroup className="input-group-alternative mb-3">
                                        <Input
                                            className="form-control-alternative"
                                            value={phone}
                                            id="input-phone"
                                            placeholder="Phone"
                                            onChange={(e) => setPhone(e.target.value)}
                                            type="number"
                                        />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <InputGroup className="input-group-alternative mb-3">
                                        <Input
                                            className="form-control-alternative"
                                            value={eventDate}
                                            placeholder='Event Date'
                                            id="input-eventDate"
                                            onChange={(e) => setEventDate(e.target.value)}
                                            type="date"
                                        />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <InputGroup className="input-group-alternative mb-3">
                                        <Input
                                            className="form-control-alternative"
                                            value={people}
                                            id="input-people"
                                            placeholder="Number of People"
                                            onChange={(e) => setPeople(e.target.value)}
                                            type="number"
                                        />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <InputGroup className="input-group-alternative mb-3">
                                        <Input
                                            type="select"
                                            name="select"
                                            id="selectVenue"
                                            onChange={(e) => setVenue(e.target.value)}
                                        >
                                            <option>Select the Venue</option>
                                            <option>Albufeira 66</option>
                                            <option>Club Heaven</option>
                                            <option>Albufissa</option>
                                            <option>Heaven Warehouse</option>
                                            <option>Club Tropicana</option>
                                            <option>Pool Party</option>
                                            <option>Boat Party</option>
                                        </Input>
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                
                                    
                                
                            </Row>
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <InputGroup className="input-group-alternative mb-3">
                                        <Input
                                            className="form-control-alternative"
                                            id="input-description"
                                            placeholder='Event description'
                                            value={desc}
                                            onChange={(e) => setDesc(e.target.value)}
                                            type="textarea"
                                            style={{ height: "100px" }}
                                        />
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="text-center">
                                <Button
                                onClick={sendHireForm}
                                className="mt-4"
                                color="primary"
                                type="button"
                                >
                                Submit
                                </Button>
                            </div>
                            {success && <span className={"text-black-50 bg-" + success.color} >{success.text}</span>}
                        </Form>
                    </GridItem>
                </GridContainer>
            </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Venue